import React from 'react';
import SettingsDatePicker from './SettingsDatePicker.component';


const SettingsDatePickerContainer = (props) => {
  return (<SettingsDatePicker {...props}/>)
}

export default SettingsDatePickerContainer;